import { getField, updateField } from 'vuex-map-fields'
import api from '@/api/api'
import { Fornecedor } from '@/models/Fornecedor'
import Swal from 'sweetalert2'
import { fornecedorTransformer } from '@/utils/transformers'

export const SET_STATE = 'SET_STATE'
export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const SUBMIT = 'SUBMIT'
export const RESET_STATE = 'RESET_STATE'
export const LOAD_PRODUTOR_FAZENDA_EMPRESA = 'LOAD_PRODUTOR_FAZENDA_EMPRESA'
export const LOAD_PRODUTOR_FAZENDA_EMPRESA_WITHOUT = 'LOAD_PRODUTOR_FAZENDA_EMPRESA_WITHOUT'
export const SUBMIT_PRODUTOR_FAZENDA_EMPRESA = 'SUBMIT_PRODUTOR_FAZENDA_EMPRESA'
export const DELETE_EMPRESA_PRODUTOR_FAZENDA = 'DELETE_EMPRESA_PRODUTOR_FAZENDA'

const getDefaultState = () => {
  return {
    picked: '',
    telefones: [
      { tipo: 'Comercial', format: 'com', title: 'Telefone', required: true },
    ],
    loading: true,
    isEditing: false,
    dialog: false,
    produtorFazendaEmpresa: [],
    produtorFazenda: [],
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { id }) {
    commit(RESET_STATE)
    commit('SET_STATE', { loading: true, isEditing: false })
    dispatch('form/BOOTSTRAP_FORM', { model: new Fornecedor() }, { root: true })
    if (id) {
      commit(SET_STATE, { isEditing: true, dialog: false })
      await api.getEntidade('fornecedor', id).then(response => {
        commit(SET_STATE, { picked: response.data[0].pessoaFis ? 'fisica' : 'juridica', loading: false })
        dispatch('form/BOOTSTRAP_FORM', { model: new Fornecedor(fornecedorTransformer(response.data[0], state.telefones)) }, { root: true })
      })
    } else {
      commit(SET_STATE, { dialog: true, loading: false, isEditing: false })
    }
  },

  async [LOAD_PRODUTOR_FAZENDA_EMPRESA] ({ commit }, { id }) {
    api.getEntidade('fornecedor/produtoresFazendas/list', id).then(response => {
      const produtores = response.data.map(item => {
      let cpf_cnpj = ''
      let nome_razao_social = ''

      let cpf_cnpj_fazenda = ''
      let nome_razao_social_fazenda = ''

      if (item.produtor && item.produtor.pessoa) {
        if (item.produtor.pessoa.tipo.includes('PessoaFisica') && item.produtor.pessoafisica) {
          cpf_cnpj = item.produtor.pessoafisica.cpf || ''
          nome_razao_social = item.produtor.pessoafisica.nome || ''
        } else if (item.produtor.pessoa.tipo.includes('PessoaJuridica') && item.produtor.pessoajuridica) {
          cpf_cnpj = item.produtor.pessoajuridica.cnpj || ''
          nome_razao_social = item.produtor.pessoajuridica.razao_social || item.produtor.pessoajuridica.nome_fantasia || ''
        }
      }

      if (item.fazenda && item.fazenda.pessoa) {
        if (item.fazenda.pessoa.tipo.includes('PessoaFisica') && item.fazenda.pessoafisica) {
          cpf_cnpj_fazenda = item.fazenda.pessoafisica.cpf || ''
          nome_razao_social_fazenda = item.fazenda.pessoafisica.nome || ''
        } else if (item.fazenda.pessoa.tipo.includes('PessoaJuridica') && item.fazenda.pessoajuridica) {
          cpf_cnpj_fazenda = item.fazenda.pessoajuridica.cnpj || ''
          nome_razao_social_fazenda = item.fazenda.pessoajuridica.razao_social || item.fazenda.pessoajuridica.nome_fantasia || ''
        }
      }

      return {
        ...item,
        cpf_cnpj,
        nome_razao_social,
        cpf_cnpj_fazenda,
        nome_razao_social_fazenda,
      }
    })
      commit(SET_STATE, { produtorFazendaEmpresa: produtores })
    })
  },

  async [LOAD_PRODUTOR_FAZENDA_EMPRESA_WITHOUT] ({ commit }) {
    api.listEntidade('fornecedor/produtoresFazendas/list').then(response => {
      const produtores = response.map(item => {
        let cpf_cnpj = ''
        let nome_razao_social = ''

        if (item.produtor && item.produtor.pessoa) {
          if (item.produtor.pessoa.tipo.includes('PessoaFisica') && item.produtor.pessoafisica) {
            cpf_cnpj = item.produtor.pessoafisica.cpf || ''
            nome_razao_social = item.produtor.pessoafisica.nome || ''
          } else if (item.produtor.pessoa.tipo.includes('PessoaJuridica') && item.produtor.pessoajuridica) {
            cpf_cnpj = item.produtor.pessoajuridica.cnpj || ''
            nome_razao_social = item.produtor.pessoajuridica.razao_social || item.produtor.pessoajuridica.nome_fantasia || ''
          }
        }

        return {
          ...item,
          cpf_cnpj,
          nome_razao_social,
        }
      })

      commit(SET_STATE, { produtorFazenda: produtores })
    })
  },

  async [SUBMIT] ({ commit, dispatch, state, rootState }, { router, user }) {
    Swal.fire({
      title: 'Cadastrando Empresa!',
      timerProgressBar: true,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
      didOpen: () => {
        const form = { ...rootState.form.data }
        form.pessoaFis = state.picked === 'fisica';
        (() => {
          commit('SET_STATE', { loading: true })
          return state.isEditing
            ? api.salvarEntidade(form, 'fornecedor', form.id)
            : api.cadastrarEntidade(form, 'fornecedor')
        })().then(
          data => {
            Swal.fire({
              title: state.isEditing
                ? 'Empresa atualizada com sucesso!'
                : 'Empresa cadastrada com sucesso!',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            })
            // dispatch(LOAD_PRODUTOR_FAZENDA_EMPRESA, { id: form.id })
            // commit(SET_STATE, { produtorFazendaEmpresa: [] })
            dispatch('fornecedores/BOOTSTRAP', null, { root: true })
            router.push({
              path: `/${user.get().role}/fornecedores`,
            })
          },
          error => {
            Swal.fire({
              icon: 'error',
              title: 'Atenção',
              text: error.errors ? error.errors : error.message,
            })
            commit(SET_STATE, { loading: false })
          },
        )
      },
    })
  },

  async [SUBMIT_PRODUTOR_FAZENDA_EMPRESA] ({ dispatch, commit, state, rootState }, { produtor_fazenda_id, empresa_id }) {
    const form = {
      produtor_fazenda_id: produtor_fazenda_id,
      empresa_id: empresa_id,
    }

    await Swal.fire({
      title: 'Vinculando produtor/fazenda a empresa!',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Vincular',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,

      preConfirm: () => {
        return api.cadastrarEntidade(form, 'fornecedor/produtoresFazendas').then(
          response => {
            dispatch(LOAD_PRODUTOR_FAZENDA_EMPRESA, { id: empresa_id })
            commit(SET_STATE, { produtorFazenda: [] })
            dispatch(LOAD_PRODUTOR_FAZENDA_EMPRESA_WITHOUT)
          },
          error => {
            window.Toast.fire(error.errors ? error.errors : error.message, '', 'error')
          },
        )
      },
    }).then((result) => {
      if (result.isConfirmed) {
        window.Toast.fire('A relação entre o Produtor/Fazenda e empresa foi criada', '', 'success')
      }
    })
  },
  async [DELETE_EMPRESA_PRODUTOR_FAZENDA] ({ dispatch, commit }, { produtorFazenda }) {
    await Swal.fire({
      title: 'Excluir relação!',
      text: 'Tem certeza que deseja excluir a relação entre o Produtor/Fazenda e a empresa?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,

      preConfirm: () => {
        return api.inativarEntidade('fornecedor/produtoresFazendas', produtorFazenda.id).then(
          response => {
            commit(SET_STATE, { produtorFazendaEmpresa: state.produtorFazendaEmpresa.filter(item => item.id !== produtorFazenda.id) })
            dispatch(LOAD_PRODUTOR_FAZENDA_EMPRESA, { id: produtorFazenda.empresa_convenio_id })
            commit(SET_STATE, { dialogVinculo: false })
          },
          error => {
            window.Toast.fire(error.errors ? error.errors : error.message, '', 'error')
          },
        ).catch(error => {
          Swal.fire(error.errors ? error.errors : error.message, '', 'error')
        })
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('A relação entre o Produtor/Fazenda e tecnico foi removida', '', 'success')
      }
    }).catch(error => {
      Swal.fire(error.errors ? error.errors : error.message, '', 'error')
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
